module.exports = __webpack_public_path__ + "img/avatar.9496f13c.png";